import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { Product } from "./product";

export class Cart extends FBase {

	items: Product[] = [];
	totalAmount: number = null;

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace Cart {
	export const PATH = 'cart';
}
